export const CALENDAR_TYPES = {
  day: 'day',
  week: 'week',
  month: 'month',
};

export const CALENDAR_START_DRAG_DELAY = 200;

export const CALENDAR_POPOVER_WIDTH = 980;
